import * as angular from "angular";

angular
  .module('bringoz.admin.addresses')
  .constant('Addresses_PN', {
    database: 'addresses',
    isBranchEntity: false
  });
